import axios from "axios";
import store from "../store";

class Password {
	password(pwd, token) {
		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/password", {
					token: token,
					password: pwd,
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	set_password(pwd) {
		let jwt = store.state.jwt;
		return new Promise(function (resolve, reject) {
			//console.log(`${process.env.VUE_APP_SAAS_BACK}` + '/users/setPassword')
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/users/setPassword",
					{
						password: pwd,
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	password_reset(username) {
		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/password_reset", {
					username: username,
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Password();
